module.exports = __webpack_public_path__ + "img/404-icon.29b2c51f.png";